var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    {
      staticClass: "ma-0 pa-0 hover_menu_list",
      class: {
        box4: _vm.viewCount === 4,
        box9: _vm.viewCount === 9,
        box16: _vm.viewCount === 16,
      },
      attrs: {
        id: "camera_select_menu" + (_vm.index_nest + _vm.indexCalc * _vm.index),
        cols: "auto",
      },
    },
    [
      _c(
        "v-list",
        { attrs: { id: "camera_menu_list" } },
        [
          !_vm.video
            ? _c(
                "v-list-item",
                {
                  attrs: { ripple: false },
                  on: {
                    click: function ($event) {
                      _vm.openCameraSearchDialog(
                        _vm.index_nest + _vm.indexCalc * _vm.index
                      )
                    },
                  },
                },
                [
                  _c("v-list-item-content", [
                    _vm._v(" " + _vm._s(_vm.tsg("changeCamera")) + " "),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.video
            ? _c(
                "v-list-item",
                {
                  attrs: { ripple: false },
                  on: {
                    click: function ($event) {
                      _vm.goVideoPlayer(
                        _vm.index_nest + _vm.indexCalc * _vm.index
                      )
                    },
                  },
                },
                [
                  _c("v-list-item-content", [
                    _vm._v(" " + _vm._s(_vm.tsg("moveToCameraViewer")) + " "),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.video
            ? _c("v-divider", {
                staticClass: "ma-0 pa-0 ml-3",
                attrs: { id: "middle_divider" },
              })
            : _vm._e(),
          _vm.video
            ? _c(
                "v-list-item",
                {
                  attrs: { ripple: false },
                  on: {
                    click: function ($event) {
                      _vm.deleteCamera(
                        _vm.index_nest + _vm.indexCalc * _vm.index
                      )
                    },
                  },
                },
                [
                  _c("v-list-item-content", [
                    _vm._v(" " + _vm._s(_vm.tsg("deleteCamera")) + " "),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }